// pt-BR das configurações de dependências do projeto (decisão D37.2). Completo: o tipo exige toda chave de en-dependencies.ts.
import type { enDependencies } from "./en-dependencies.ts";

export const ptBRDependencies: Record<keyof typeof enDependencies, string> = {
  "deps.title": "Dependências",
  "deps.body":
    "Antes dos testes e das builds, a sandbox instala as dependências do projeto com este comando. Ele só alcança os registros de pacotes (npm, Yarn), por um proxy com lista de permissões; testes e builds continuam sem rede. Ele roda de novo só quando um lockfile ou package.json muda.",
  "deps.workspace": "Comando de instalação — {path}",
  "deps.hint": "Definido só por uma pessoa. Agentes e o assistente podem sugerir; nada roda até você salvar.",
  "deps.suggested": "Detectado {lockfile}: {command}",
  "deps.useSuggestion": "Usar este",
  "deps.noLockfile": "Nenhum lockfile encontrado no checkout informado pelo worker.",
  "deps.unknownFacts": "O worker ainda não informou este checkout: valide o projeto para atualizar.",
  "deps.allowScripts": "Executar os scripts de instalação dos pacotes",
  "deps.allowScriptsHint": "Desligado por padrão: scripts de instalação são código não confiável. Ligue só se o projeto não compilar sem eles.",
  "deps.registryOk": "Registros de pacotes acessíveis pelo proxy da sandbox",
  "deps.registryOff": "A instalação de dependências ainda não foi verificada na sandbox do worker",
  "deps.cached": "Gerenciadores de pacotes na imagem da sandbox: {list}",
  "deps.cachedNone": "A imagem da sandbox não tem pnpm nem Yarn (gere deploy/sandbox-runner)",
  "deps.asks": "O repositório pede {pm}",
  "deps.lastInstalled": "Última instalação concluída {when}",
  "deps.lastFailed": "Última instalação falhou {when}: {cause}",
  "deps.saved": "Configurações de dependências salvas. Valide o projeto para atualizar as verificações de prontidão.",
  "deps.readOnly": "Só mantenedores do projeto podem mudar o comando de instalação de dependências.",
  "deps.cause.prepare_not_configured": "As dependências nunca são instaladas: o workspace não tem comando de instalação",
  "deps.cause.prepare_failed": "A instalação das dependências falhou",
  "deps.cause.package_manager_missing": "O gerenciador de pacotes não está na imagem da sandbox",
  "deps.cause.registry_unreachable": "Não foi possível alcançar os registros de pacotes",
  "deps.cause.package_manager_fallback": "Outra versão do gerenciador de pacotes é usada",
  "assistant.field.prepare_command": "o comando de instalação de dependências",
};
